export default "__VITE_ASSET__DShsDgx2__"